<!--
    This is the dashboard layout, used in dashboard, tables, billing and profile pages.
 -->
<template>
    <div>
        <!-- Dashboard Layout -->
        <a-layout 
            class="layout-dashboard" 
            id="layout-dashboard" 
            :class="[navbarFixed ? 'navbar-fixed' : '', !sidebarCollapsed ? 'has-sidebar' : '', layoutClass]"
        >
           
            <!-- Main Sidebar -->
            <DashboardSidebar
                :sidebarCollapsed="sidebarCollapsed"
                :sidebarColor="sidebarColor"
                :sidebarTheme="sidebarTheme"
                @toggleSidebar="toggleSidebar"
            />
            <!-- / Main Sidebar -->

            <!-- Layout Content -->
            <a-layout>
                <!-- Layout Header's Conditionally Fixed Wrapper -->
                <DashboardHeader
                    :sidebarCollapsed="sidebarCollapsed"
                    :navbarFixed="navbarFixed"
                    @toggleSidebar="toggleSidebar"
                />
                <!-- / Layout Header's Conditionally Fixed Wrapper -->

                <!-- Page Content -->
                <a-layout-content>
                    <router-view />
                </a-layout-content>
                <!-- / Page Content -->

                <!-- Layout Footer -->
                <DashboardFooter />
                <!-- / Layout Footer -->

                <!-- Sidebar Overlay -->
                <div 
                    class="sidebar-overlay" 
                    @click="sidebarCollapsed = true" 
                    v-show="!sidebarCollapsed"
                />
                <!-- / Sidebar Overlay -->
            </a-layout>
            <!-- / Layout Content -->
           
        </a-layout>
        <!-- / Dashboard Layout -->
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import DashboardSidebar from '../components/Sidebars/DashboardSidebar.vue';
import DashboardHeader from '../components/Headers/DashboardHeader.vue';
import DashboardFooter from '../components/Footers/DashboardFooter.vue';

const route = useRoute();

// Sidebar collapsed status
const sidebarCollapsed = ref(false);

// Main sidebar color
const sidebarColor = ref('primary');

// Main sidebar theme: light, white, dark
const sidebarTheme = ref('light');

// Header fixed status
const navbarFixed = ref(false);

// Methods
const toggleSidebar = (value) => {
    sidebarCollapsed.value = value;
};

const toggleNavbarPosition = (value) => {
    navbarFixed.value = value;
};

const updateSidebarTheme = (value) => {
    sidebarTheme.value = value;
};

const updateSidebarColor = (value) => {
    sidebarColor.value = value;
};

// Computed
// Sets layout's element's class based on route's meta data
const layoutClass = computed(() => {
    return route.meta.layoutClass;
});
</script>